import {rest} from './rest';

import * as constants from './constants';
import * as selectors from './selectors';

export const contact = {
    rest,
    constants,
    selectors,
};
